import { Component, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { AppSettingsModel, Asset } from 'src/app/Modelo/AppSettings.Model';
import { SettingsService } from 'src/app/servicios/settings.service';

@Component({
  selector: 'app-swiper-home',
  templateUrl: './swiper-home.component.html',
  styleUrls: ['./swiper-home.component.scss']
})
export class SwiperHomeComponent implements OnInit {
  private _appSettings: AppSettingsModel;
  public ConfigurationSlider: SwiperOptions = {

		init: true,
		speed: 1500,
    slidesPerView:  1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: "#home-banner-next",
      prevEl: "#home-banner-prev",
    },
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
      waitForTransition: true
    },
	};
  
  get homeBanners(): Array<Asset> {
    return this._appSettings?.swiperHome?.filter(b => b.visible) ?? new Array<Asset>();
  }

  constructor(private _appSettingsService: SettingsService) { }

  ngOnInit(): void {
    this._appSettingsService.get().then((appSettings: AppSettingsModel) => this._appSettings = appSettings);
  }

  isMobile(): boolean {
    return window.innerWidth < 500 ;
  }
}
